export default __webpack_public_path__ + "static/media/b8674ebc-27b8-43c0-9e24-afcdb66daea2.30437fcf.jpeg";